<!-- 异常（遥控）开闸数据上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carClass": 1,
                "cmd": "reportAbnormalCar",
                "enterCarCode": "未识别0927123257970",
                "enterChannelCode": "5628",
                "enterImageArray": [
                    {
                        "carImage": "http://221.4.168.157:13388/openydt/files/images/2017092712325702026573-body-in-aog.jpg?s=776d6ecd",
                        "plateImage": "http://221.4.168.157:13388/openydt/files/images/2017092712325702026573-plate-in-aog.jpg?s=c5b1b703"
                    }
                ],
                "enterReliability": 0,
                "enterType": 5,
                "finalReliability": 0,
                "inDate": "20170927123257",
                "leaveImageArray": [
                    {
                        "carImage": "http://221.4.168.157:13388/openydt/files/images/2017092712325702026573-body-out-aog.jpg?s=26983ebf",
                        "plateImage": "http://221.4.168.157:13388/openydt/files/images/2017092712325702026573-plate-out-aog.jpg?s=3c33ab3a"
                    }
                ],
                "leaveReliability": 0,
                "outerType": 0,
                "parkCode": "2KKN6111",
                "parkingCode": "2017092712325702026573",
                "realCharge": 0,
                "recordType": 1,
                "reliefCharge": 0,
                "openGateTime": 500,
                "shouldCharge": 0
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场异常开闸数据到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportAbnormalCar",
                precondition: "无",
                fitSystem: "VEMS传统停车场 (上报图片保留90天)",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车流水' },
                        { info1: 'enterCarCode', info2: '是', info3: 'String', info4: '车牌' },
                        { info1: 'cardCode', info2: '是', info3: 'String', info4: '卡编号' },
                        { info1: 'enterAddress', info2: '是', info3: 'String', info4: '入口位置' },
                        { info1: 'enterChannelCode', info2: '是', info3: 'String', info4: '入口通道编号' },
                        { info1: 'finalReliability', info2: '是', info3: 'Decimal', info4: '综合车牌最终识别可信度' },
                        { info1: 'carClass', info2: '是', info3: 'int', info4: '0未知，1小车，2大车，3超大车，4中型车' },
                        { info1: 'enterReliability', info2: '是', info3: 'Decimal', info4: '进场识别置信度' },
                        { info1: 'favorPrice', info2: '是', info3: 'Decimal', info4: '折扣价' },
                        { info1: 'enterType', info2: '是', info3: 'int', info4: '进场类型（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'enterImageArray', info2: '是', info3: 'JSONArray', info4: '进场图片列表，[{"plateImage":"车牌图片直接访问url","carImage":"车身图片直接访问url"}]' },
                        { info1: 'shouldCharge', info2: '是', info3: 'Decimal', info4: '停车费用' },
                        { info1: 'reliefCharge', info2: '否', info3: 'Decimal', info4: '减免金额' },
                        { info1: 'realCharge', info2: '否', info3: 'Decimal', info4: '实缴金额' },
                        { info1: 'outerAddress', info2: '是', info3: 'String', info4: '出口位置' },
                        { info1: 'outerChannelCode', info2: '否', info3: 'String', info4: '离场通道编号' },
                        { info1: 'leaveReliability', info2: '是', info3: 'String', info4: '车牌原识别置信度' },
                        { info1: 'leaveCarCode', info2: '是', info3: 'String', info4: '原车牌' },
                        { info1: 'leaveImageArray', info2: '是', info3: 'JSONArray', info4: '出场图片列表，[{"plateImage":"车牌图片直接访问url","carImage":"车身图片直接访问url"}]' },
                        { info1: 'outerType', info2: '是', info3: 'int', info4: '出场类型（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作员' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'recordType', info2: '是', info3: 'int', info4: '记录类型	1进场 2出场' },
                        { info1: 'openGateType', info2: '否', info3: 'int', info4: '非系统开闸类型: 0未确认，1遥控开闸，2可疑跟车（vems2.14及以上版本支持）' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportAbnormalCar.vue